/**
 * Returns the PayPal locale string for the current deployment locale.
 *
 * Switzerland uses it_IT — PayPal does not support it_CH.
 * PayPal locale docs: https://developer.paypal.com/api/nvp-soap/locale-codes/
 */
export function getPayPalExpressLocale(locale?: string): string {
  const normalized = locale ?? '';
  const isCH = normalized.endsWith('-CH');

  return isCH ? 'it_IT' : normalized.replace('-', '_');
}
